(function () {
  'use strict';

  var SCROLL_SHOW = 320;
  var CIRCUMFERENCE = 2 * Math.PI * 24;

  function init() {
    var btn = document.querySelector('[data-eastdtc-scroll-top]');
    if (!btn) return;

    var progress = btn.querySelector('[data-scroll-progress]');
    var ticking = false;

    function getScrollY() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function getScrollMax() {
      var doc = document.documentElement;
      return Math.max(0, (doc.scrollHeight || 0) - window.innerHeight);
    }

    function update() {
      ticking = false;
      var y = getScrollY();
      var max = getScrollMax();
      var ratio = max > 0 ? Math.min(1, y / max) : 0;

      if (y > SCROLL_SHOW) {
        btn.hidden = false;
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
        btn.hidden = true;
      }

      if (progress) {
        progress.style.strokeDasharray = String(CIRCUMFERENCE);
        progress.style.strokeDashoffset = String(CIRCUMFERENCE * (1 - ratio));
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    btn.addEventListener('click', function () {
      var prefersReduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReduced) {
        window.scrollTo(0, 0);
        return;
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
